"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5485],{

/***/ 23685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Movie = (param)=>{
    let { background , movie  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "movie paddingsForBlocks ".concat(background === "grey" ? "mainBackgroundGrey" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "blocks__desktopWrapper movie__container",
            dangerouslySetInnerHTML: {
                __html: movie && movie.videoEmbed || ""
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Movie);


/***/ }),

/***/ 15485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ TwoColumns_TwoColumns; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
// EXTERNAL MODULE: ./src/blocks/Movie/Movie.tsx
var Movie = __webpack_require__(23685);
;// CONCATENATED MODULE: ./src/blocks/TwoColumns/TwoColumns.tsx




const ALIGNMENT_LEFT = "left";
const TwoColumns = (param)=>{
    let { blockData  } = param;
    const { data: { header , content , element , alignment , picture , video , background  }  } = blockData;
    const buttons = Object.values(element);
    const direction = ()=>({
            flexDirection: alignment === ALIGNMENT_LEFT ? "row" : "row-reverse"
        });
    const getStyle = (button)=>".twoColumns--baseButton".concat(getButtonUniqClass(button), " {\n                        background-color: ").concat(button.background_color, ";\n                        border-color: ").concat(button.border_color, ";\n                        color: ").concat(button.text_color, "!important;\n                    }\n\n                    .twoColumns--baseButton").concat(getButtonUniqClass(button), ":after {\n                        background-color: ").concat(button.background_color, ";\n                    }\n\n                    .twoColumns--baseButton").concat(getButtonUniqClass(button), ":before {\n                        background-color: ").concat(button.background_color_hover, ";\n                    }\n\n                    .twoColumns--baseButton").concat(getButtonUniqClass(button), ":hover {\n                          color: ").concat(button.text_color_hover, "!important;\n                          border-color: ").concat(button.border_color_hover, ";\n                          background-color: ").concat(button.background_color_hover, ";\n                    }\n\n                    .twoColumns--baseButton").concat(getButtonUniqClass(button), ":hover > svg {\n                            fill: ").concat(button.text_color_hover, ";\n                          }\n                    ");
    const getButtonUniqClass = (param)=>{
        let { text_color , background_color  } = param;
        return "".concat(background_color.replace("#", "")).concat(text_color.replace("#", ""));
    };
    const isAlignLeft = ()=>alignment === ALIGNMENT_LEFT;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor: background
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "twoColumns desktop-container",
            style: direction(),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "twoColumns--imgContainer ".concat(isAlignLeft() ? "marginRightDesktop-30" : ""),
                    children: [
                        !video && picture && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                            data: picture
                        }),
                        video && /*#__PURE__*/ (0,jsx_runtime.jsx)(Movie/* default */.Z, {
                            movie: video
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "twoColumns--contentContainer ".concat(isAlignLeft() ? "" : "marginRightDesktop-30"),
                    children: [
                        header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "twoColumns--header",
                            children: header
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "twoColumns--content",
                            dangerouslySetInnerHTML: {
                                __html: content
                            }
                        }),
                        buttons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "twoColumns--buttonsContainer",
                            children: buttons.map((button, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                            children: "\n                      ".concat(getStyle(button), "\n                    ")
                                        }, button.url),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "twoColumns--baseButton modern-button twoColumns--baseButton".concat(getButtonUniqClass(button)),
                                                target: button.target,
                                                rel: "noopener noreferrer",
                                                href: button.url,
                                                children: button.anchor
                                            }, index)
                                        }, index)
                                    ]
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TwoColumns_TwoColumns = (TwoColumns);

;// CONCATENATED MODULE: ./src/blocks/TwoColumns/index.ts



/***/ })

}]);